import { ConstraintLeaseObligationBase } from './base/constraint-lease-obligation-base';

export class ConstraintLeaseObligation extends ConstraintLeaseObligationBase { }